import React, { useEffect } from "react";
import html2pdf from "html2pdf.js";
import Lenis from "@studio-freight/lenis";
import "./css/resume.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Resume = () => {
  useEffect(() => {
    const lenis = new Lenis();
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    return () => {
      lenis.off("scroll");
    };
  }, []);

  const generatePDF = () => {
    const element = document.getElementById("resume-container");
    const options = {
      margin: 1,
      filename: "Ambrose-resume.pdf",
      html2canvas: { scale: 4 },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
        compress: true,
      },
    };

    html2pdf().from(element).set(options).save();
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="body-resume-container" id="resume-container1">
        <div id="resume-container">
          <header>
            <h1>AMBROSE OTHNIEL</h1>
            <p>
              <span className="heading-detail">FRONT END DEVELOPER</span>{" "}
              <span className="heading-detail">
                <i className="fa-solid fa-location-dot"></i>LAGOS,NIGERIA
              </span>{" "}
              <span className="heading-detail">
                <i className="fa-solid fa-phone"></i>+2348085186024
              </span>
            </p>
          </header>

          <div className="res-container">
            <div className="left-column">
              <section>
                <h2>SKILLS</h2>
                <ul>
                  <li>HTML5</li>
                  <li>CSS3</li>
                  <li>JavaScript</li>
                  <li>Bootstrap</li>
                  <li>Sass</li>
                  <li>Tailwind CSS</li>
                  <li>GSAP</li>
                  <li>Git</li>
                  <li>React (In Progress)</li>
                </ul>
              </section>
              <section>
                <h2>LINKS</h2>
                <ul>
                  <li>
                    <a
                      href="mailto:ambroseothniel1@gmail.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      mail
                    </a>
                  </li>
                  <li>
                    <Link to="/">Portfolio</Link>
                  </li>
                  <li>
                    <a
                      href="https://github.com/Broseey"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Github
                    </a>
                  </li>
                  <li>
                    <a
                      href="www.linkedin.com/in/ ambrose-othniel"
                      target="_blank"
                    >
                      Linkedn
                    </a>
                  </li>
                </ul>
                <span className="mini-detail">
                  <h2>LANGUAGE</h2>
                  <ul>
                    <li>English</li>
                  </ul>
                </span>
              </section>
              <section>
                <h2>LANGUAGE</h2>
                <ul>
                  <li>English</li>
                </ul>
              </section>
            </div>
            <div className="right-column">
              <section className="profile">
                <i className="fa-solid fa-user"></i>
                <h2>Profile</h2>
                <span className="ruler">
                  <p className="circle-symbols">
                    Results-driven Front-End Developer with expertise in HTML,
                    CSS, JavaScript, Bootstrap, Gsap ,and Tailwind CSS with
                    SASS. Currently expanding skills by delving into React.
                    Proven track record in developing dynamic and user-friendly
                    interfaces.
                  </p>
                </span>
              </section>
              <section className="experience">
                <i className="fa-solid fa-briefcase"></i>
                <h2>Work Experience</h2>
                <span className="ruler">
                  <p className="circle-symbols">
                    <strong>Freelance Web Developer </strong>
                    <br /> July 2023 – Present
                  </p>
                  <ul>
                    <li>
                      Succesfully transitioned from personal projects undertaken
                      between 2020 and 2023 to freelancing upon completing my
                      undergraduate studies in june 2023
                    </li>
                    <li>
                      Developed Convoservice, a dynamic and user-friendly web
                      app for a transport company in Ado-Ekiti, Nigeria.
                      <ul>
                        <li>
                          Enabled clients to seamlessly book rides within the
                          city, enhancing user experience and accessibility
                        </li>
                        <li>
                          implemented integration with a form API for
                          streamlined data processing, optimizing the overall
                          efficiency of the booking system
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <p className="circle-symbols">
                    <strong>Freelance Portfolio Developer</strong>
                    <br /> July 2023 – Present
                  </p>
                  <ul>
                    Designed and implemented visually appealing portfolio
                    websites for various clients, including a portfolio for a
                    designer. The goal was to enhance their ability to showcase
                    their work effectively to potential clients and employers.
                    <li>
                      Created a portfolio website for a designer to showcase
                      their work and skills.
                    </li>
                    <li>
                      Designed and developed portfolio site demos for potential
                      clients.
                    </li>
                  </ul>
                </span>
              </section>
              <section>
                <i className="fa-solid fa-graduation-cap"></i>
                <h2>Education</h2>
                <span className="ruler">
                  <p className="circle-symbols">
                    <strong>Bachelor of Science in Computer Engineering</strong>
                  </p>
                  <p>Afe Babalola University Ado Ekiti (ABUAD)</p>
                  <p>September 2018 - June 2023 (5 years)</p>
                </span>
              </section>
              <section className="projects">
                <i className="fa-solid fa-clipboard"></i>
                <h2>Projects</h2>
                <span className="ruler">
                  <p className="circle-symbols">
                    <strong>Personal Projects</strong>
                  </p>
                  <ul>
                    Developed a visually striking gallery website, a
                    well-laid-out real estate website, and a web app for curated
                    music playlists. These projects demonstrate a commitment to
                    creating aesthetically pleasing and functionally rich
                    websites.
                    <li>
                      Real Estate Site - Developed real estate website for
                      realtors, providing a platform for showcasing property
                      listings and facilitating direct contact with agent.
                    </li>
                    <li>
                      Art Gallery Site - Developed a website for an art gallery
                      to exhibit artwork.
                    </li>
                    <li>
                      Music Player Site - Created a site that plays your
                      favorite music and displays the artist's picture.
                    </li>
                  </ul>
                  <p>
                    Explore more projects on my{" "}
                    <Link to="/">
                      <strong>portfolio</strong>
                    </Link>
                    . <br />
                    I'm available to discuss my projects in greater detail at a
                    scheduled time. Feel free to request additional information
                    about methodologies, technologies, and outcomes at your
                    convenience.
                  </p>
                </span>
              </section>
            </div>
          </div>
        </div>
        <button className="main-btn" onClick={generatePDF}>
          Download as PDF <i className="fa-solid fa-file-arrow-down"></i>
        </button>
        <button className="mini-btn" onClick={generatePDF}>
          <i className="fa-solid fa-download"></i>
        </button>{" "}
        <span class="resume-prev-btn">
          <Link to="/">
            <svg
              width="35"
              height="35"
              viewBox="0 0 138 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_i_1_2)">
                <path
                  d="M0.89439 19.8704C-0.285828 21.0333 -0.299898 22.9327 0.862964 24.113L19.8129 43.3457C20.9758 44.526 22.8752 44.54 24.0554 43.3772C25.2356 42.2143 25.2497 40.3149 24.0869 39.1346L7.24246 22.0388L24.3383 5.19444C25.5185 4.03158 25.5326 2.13213 24.3697 0.951916C23.2068 -0.228303 21.3074 -0.242373 20.1272 0.92049L0.89439 19.8704ZM137.022 20.0001L3.02216 19.0075L2.97772 25.0073L136.978 25.9999L137.022 20.0001Z"
                  fill="black"
                ></path>
              </g>
              <defs>
                <filter
                  id="filter0_i_1_2"
                  x="-6.10352e-05"
                  y="0.0574646"
                  width="137.022"
                  height="48.1827"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                  ></feFlood>
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  ></feBlend>
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  ></feColorMatrix>
                  <feOffset dy="4"></feOffset>
                  <feGaussianBlur stdDeviation="2"></feGaussianBlur>
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  ></feComposite>
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  ></feColorMatrix>
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_1_2"
                  ></feBlend>
                </filter>
              </defs>
            </svg>
            <span class="olk ">back</span>
          </Link>
        </span>
      </div>
    </motion.div>
  );
};

export default Resume;
